exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".AppRoleList {\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/AppRoleList.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;CACd","file":"AppRoleList.css","sourcesContent":[".AppRoleList {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/css/AppRoleList.css
// module id = yq9d
// module chunks = 1